<script setup lang="ts">
const show = defineModel<boolean>()

const { activeProduct, activeVariant } = storeToRefs(useProductVariantsStore())
</script>

<template>
  <UModal
    v-model="show"
    header-class="!p-0 !pt-4 !md:pt-8 !pr-4 !md:pr-8"
    :close-on-click-outside="false"
    custom-class="!max-w-4xl md:w-auto"
    custom-body-class="px-7 md:px-11 mb-0 pb-11"
    custom-inner-class="!bg-platform-paper"
  >
    <div
      v-if="activeProduct && activeVariant"
      class="flex flex-col items-center space-y-6 md:space-y-10"
    >
      <UPaywallHeader @close="show = false" />

      <UPaywallStats />

      <UPaywallPricing v-if="!activeVariant.isFree" />

      <UButton
        v-if="!activeVariant.isFree"
        variant="filled"
        theme="cta"
        pill
        size="md"
        data-pendo="paywall-kjop-tilgang"
        bold
        :to="{
          path: `/produkter/${activeProduct.urlFormatProductTitle}/betaling`,
          query: {
            variant: activeVariant.variantKey,
          },
        }"
      >
        Kjøp tilgang
      </UButton>
      <UButton
        v-else
        :to="`/produkter/${activeProduct.urlFormatProductTitle}/registrer-interesse`"
        :data-pendo="`paywall-hold-meg-oppdatert-${activeProduct.urlFormatProductTitle}`"
        variant="filled"
        theme="cta"
        size="md"
        pill
      >
        Hold meg oppdatert
      </UButton>
    </div>
  </UModal>
</template>
